import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button, Label } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { initializeForm, preCheckForm, RecurringCommissionType } from "../types";
// import {
//   updateRecurringCommission,
//   getRecurringCommission,
//   bookRecurringCommission
// } from '../../../services/api/recurringCommissions';
import AccountsGrid from "./AccountsGrid";
import { parseDate, CustomFormInput, Mode, SelectFormField } from "../../../../utils";
import { showToast } from "../../../../utils/Helper";
import { FormattedDate } from "react-intl";
import Combobox from "../../Order/Field/Combobox";

const ModalRecurringCommission = ({ open, toggle, initialCommission, mode, fetchs }) => {
  const [commission, setCommission] = useState(initializeForm(initialCommission));
  const [accounts, setAccounts] = useState(undefined);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [booking, setBooking] = useState(false);
  const [searching, setSearching] = useState(false);
  const [currency, setCurrency] = useState(1);
  const [currencies, setCurrencies] = useState([]);
  const [downloading, setdownloading] = useState(false);
  const [isCommissionCreated, setIsCommissionCreated] = useState(false);
  // Month quick-select removed: user defines explicit From / To dates now.

  useEffect(() => {
    if (initialCommission != undefined) {
      setCurrency(initialCommission.currencyId);
    }
  }, []);

  useEffect(() => {
    fetchs.fetchGetCurrencies().then((r) => {
      let currenciesAux = [];
      r.currencies.map((currency) => {
        currenciesAux.push({ id: currency.currencyId, description: currency.currencyDescription });
      });
      setCurrencies(currenciesAux);
    });
  }, []);

  // Removed auto previous-month fill; user chooses dates manually.

  const onChangeCurrency = (newCurrency) => {
    setCurrency(newCurrency);
  };

  // onChangeMonth removed.

  const onChange = (name, value, stringValue) => {
    setCommission((c) => {
      const newC = {
        ...c,
        [name]: value,
      };
      return newC;
    });
    setErrors((e) => {
      const newE = { ...e };
      delete newE[name];
      delete newE.globalError;
      return newE;
    });
    if (name === "RecurringCommissionType") {
      setAccounts(undefined);
    }
  };

  const afterSave = (res, book) => {
    setLoading(false);
    if (res && res.result && res.result.Code === 200) {
      if (book) {
        fetchs.bookRecurringCommission({ id: commission.RecurringCommissionId }, (res2) => {
          setBooking(false);
          if (res2 && res2.result && res2.result.Code === 200) {
            toggle(undefined, true);
            showToast("Recurring Commission Booked!");
          } else {
            showToast(res2 && res2.result ? res2.result.Description : "Server Error", true);
          }
        });
      } else {
        toggle(undefined, true);
        showToast("Changes saved successfully!");
      }
    } else {
      showToast(res && res.result ? res.result.Description : "Server Error", true);
    }
  };

  const handleSearch = () => {
    setSearching(false);
    fetchs.updateRecurringCommission(
      {
        k2btrnmode: "INS",
        recurringcommissionsdt: { ...commission, currencyId: currency },
      },
      (res) => {
        try {
          const { result, id } = res;
          if (result.Code === 200) {
            fetchs.getRecurringCommission({ id }, (resp) => {
              try {
               if (
                 resp &&
                 resp.reccommission &&
                 resp.reccommission.RecurringCommissionStatus == "Initiated"
               ) {
                 showToast("Commission created successfully!");
                 setSearching(false);
                 setAccounts(resp.reccommission.Accounts);
                 setCommission(initializeForm(resp.reccommission));
                 setIsCommissionCreated(true);
               } else {
                 if (
                   resp &&
                   resp.reccommission &&
                   resp.reccommission.RecurringCommissionStatus == "Validated"
                 ) {
                   showToast("Commission scheduled for this night.");
                   setSearching(false);
                   handleClose();
                   setIsCommissionCreated(true);
                 }else{
                  showToast("Commission already exists");
                  setSearching(false);
                  setIsCommissionCreated(false);
                  handleClose();
                 }
               }
              } catch (e) {
                showToast("Server Error", true);
              }
            });
          } else {
            showToast(result.Description || "Server Error", true);
          }
        } catch (e) {
          showToast("Server Error", true);
        }
      }
    );
  };

  const handleSave = (book) => {
    // Validate dates before proceeding
    const dateErrors = {};
    if (!commission.RecurringCommissionFrom) {
      dateErrors.RecurringCommissionFrom = "Required";
    }
    if (!commission.RecurringCommissionTo) {
      dateErrors.RecurringCommissionTo = "Required";
    }
    if (commission.RecurringCommissionFrom && commission.RecurringCommissionTo) {
      if (new Date(commission.RecurringCommissionFrom) > new Date(commission.RecurringCommissionTo)) {
        dateErrors.RecurringCommissionTo = "'To' must be after 'From'";
      }
    }
    if (Object.keys(dateErrors).length) {
      setErrors((e) => ({ ...e, ...dateErrors }));
      return;
    }
    const body = {
      k2btrnmode: "UPD",
      recurringcommissionsdt: { ...commission, Accounts: accounts, currencyId: currency },
    };

    const newErrors = preCheckForm({ ...commission });
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    if (book) {
      setBooking(true);
    } else {
      setLoading(true);
    }
    fetchs.updateRecurringCommission(body, (res) => afterSave(res, book));
  };

  const handleClose = () => {
    toggle(undefined, commission.RecurringCommissionId && !initialCommission);
  };

  const getTitle = () => {
    if (mode !== Mode.EDIT) return "Recurring Commission";
    if (initialCommission === undefined) return "New Recurring Commission";
    return "Edit Recurring Commission";
  };

  const handleChangeAccount = (index, volume) => {
    const tax = parseFloat(commission.VAT) / 100;
    setAccounts((a) =>
      a.map((acc, i) => {
        const newAcc = { ...acc };
        if (i === index) {
          const v = Number(volume) || 0;
          const rate = Number(commission.VAT) / 100 || 0;
          newAcc.RecurringCommissionVolume = v;
          newAcc.RecurringCommissionTax = v * rate;
          newAcc.RecurringCommissionTotal = v + newAcc.RecurringCommissionTax;
        }
        return newAcc;
      })
    );
  };

  useEffect(() => {
    if (!accounts && initialCommission) {
      setSearching(true);
      fetchs.getRecurringCommission({ id: initialCommission.RecurringCommissionId }, (res) => {
        setAccounts(res.reccommission.Accounts);
        setSearching(false);
        setCommission({ ...res.reccommission });
        setIsCommissionCreated(true);
      });
    }
  }, [accounts, initialCommission]);

  const concatData = async () => {
    setdownloading(true);
    let client = [];

    client = [...commission.Accounts];

    const recurringCommissionCurrency = currencies.find((item) => item.id === commission.currencyId);
    let clientdata = [];
    for (var j = 0; j < client.length; j++) {
      let item = {};
      item = {
        accountNumber: client[j].AccountNumber,
        accountName: client[j].AccountName,
        clientName: client[j].ClientName,
        clientDocumentNumber: client[j].ClientDocumentNumber,
        currency: recurringCommissionCurrency.description,
        bankAccount: client[j].BankAccountNumber,
        average: client[j].RecurringCommissionBaseCalculationShow,
        percentage:  client[j].RecurringCommissionFee?client[j].RecurringCommissionFee:commission.commissionRecurringVolume.replace(".", ","),
        commission: client[j].RecurringCommissionVolumeShow,
        ivaIICB: client[j].RecurringCommissionTaxShow,
        totalIICB: client[j].RecurringCommissionTotalShow,
        feePercentage: client[j].RecurringCommissionFee !== undefined ? String(client[j].RecurringCommissionFee).replace('.', ',') : '',
        feeAmount:
          client[j].RecurringCommissionFee !== undefined
            ? (Number(client[j].RecurringCommissionVolume || 0) * Number(client[j].RecurringCommissionFee) / 100)
                .toFixed(2)
                .replace('.', ',')
            : '',
      };

      clientdata.push(item);
    }

    let response = undefined;
    let body = {
      id: commission.RecurringCommissionId,
      clients: clientdata,
    };

    await fetchs
      .recurringCommissionXLSX(body)
      .then((r) => {
        if (r.response.count > 0) {
          response = r.response.buffer.data;

          try {
            const blob = new Blob([new Uint8Array(response)], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "RecurringCommission" + String(commission.RecurringCommissionId) + ".xlsx";
            link.click();
            setdownloading(false);
          } catch (ex) {}
        }
      })
      .catch((e) => {
        console.error(e);
      });
    //setReportResponse(response);
  };

  const disabled = mode !== Mode.EDIT;

  const handleChangeDate = (name, value) => {
    setCommission((c) => ({ ...c, [name]: value }));
    setErrors((e) => { const n = { ...e }; delete n[name]; return n; });
  };

  return (
    <Modal isOpen={open} toggle={handleClose} style={{ maxWidth: 700 }}>
      <ModalHeader>{getTitle()}</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <SelectFormField
              label="Type"
              name="RecurringCommissionType"
              error={errors.RecurringCommissionType}
              value={commission.RecurringCommissionType}
              onChange={onChange}
              selectItems={[""].concat(Object.keys(RecurringCommissionType))}
              getSelectItemId={(i) => i}
              getSelectItemName={(i) => RecurringCommissionType[i]}
              disabled={commission.RecurringCommissionId}
            />
          </Col>
          <Col>
            <Label
              style={{
                fontWeight: 500,
                fontSize: "15px",
                display: "block",
                color: "black",
              }}
            >
              Currency
            </Label>
            <Combobox
              label="Currency"
              items={currencies}
              value={currency}
              onChange={onChangeCurrency}
              disabled={commission.RecurringCommissionId}
            />
          </Col>
          {/* Month quick-select removed */}
          {!commission.RecurringCommissionId && (
            <Col style={{ marginTop: "28px" }}>
              <LaddaButton
                style={{ width: "100%" }}
                className="btn btn-ladda btn-primary"
                loading={searching}
                disabled={!commission.RecurringCommissionType}
                onClick={handleSearch}
                data-style={EXPAND_RIGHT}
              >
                {searching ? "Creating..." : "Create"}
              </LaddaButton>
            </Col>
          )}
        </Row>
        {(commission.RecurringCommissionType) && (
          <Row>
            <Col>
              <Label
                style={{
                  fontWeight: 500,
                  fontSize: "15px",
                  display: "block",
                  color: errors.RecurringCommissionFrom ? "#dc3545" : "black",
                }}
              >
                From
              </Label>
              <input
                type="date"
                className={`form-control ${errors.RecurringCommissionFrom ? 'is-invalid' : ''}`}
                value={commission.RecurringCommissionFrom || ''}
                onChange={(e) => handleChangeDate('RecurringCommissionFrom', e.target.value)}
                disabled={commission.RecurringCommissionId && disabled}
              />
              {errors.RecurringCommissionFrom && (
                <div className="invalid-feedback" style={{ display: 'block' }}>{errors.RecurringCommissionFrom}</div>
              )}
            </Col>
            <Col>
              <Label
                style={{
                  fontWeight: 500,
                  fontSize: "15px",
                  display: "block",
                  color: errors.RecurringCommissionTo ? "#dc3545" : "black",
                }}
              >
                To
              </Label>
              <input
                type="date"
                className={`form-control ${errors.RecurringCommissionTo ? 'is-invalid' : ''}`}
                value={commission.RecurringCommissionTo || ''}
                onChange={(e) => handleChangeDate('RecurringCommissionTo', e.target.value)}
                disabled={commission.RecurringCommissionId && disabled}
              />
              {errors.RecurringCommissionTo && (
                <div className="invalid-feedback" style={{ display: 'block' }}>{errors.RecurringCommissionTo}</div>
              )}
            </Col>
          </Row>
        )}
        {commission.RecurringCommissionId && (
          <AccountsGrid
            accounts={accounts}
            handleChange={handleChangeAccount}
            disabled={disabled}
            fetchs={fetchs}
            commission={commission}
            status={commission.RecurringCommissionStatus}
          />
        )}
      </ModalBody>
      <ModalFooter>
        {!isCommissionCreated && (
          <LaddaButton
            className="btn btn-ladda btn-primary ml-2 mr-2"
            loading={downloading}
            disabled={true}
            onClick={() => concatData()}
            data-style={EXPAND_RIGHT}
          >
            <i className="fa fa-download"></i>
          </LaddaButton>
        )}
        {isCommissionCreated && (
          <LaddaButton
            className="btn btn-ladda btn-primary ml-2 mr-2"
            loading={downloading}
            disabled={false}
            onClick={() => concatData()}
            data-style={EXPAND_RIGHT}
          >
            <i className="fa fa-download"></i>
          </LaddaButton>
        )}
        <Button
          color="secondary"
          onClick={handleClose}
          style={{ marginRight: 10 }}
          disabled={loading || booking}
        >
          Close
        </Button>
        {accounts && !disabled && (
          <React.Fragment>
            <LaddaButton
              className="btn btn-ladda btn-primary"
              loading={loading}
              disabled={Object.keys(errors).length > 0 || booking}
              onClick={() => handleSave(false)}
              data-style={EXPAND_RIGHT}
            >
              {loading ? "Saving" : "Save"}
            </LaddaButton>
            <LaddaButton
              className="btn btn-ladda btn-warning"
              loading={booking}
              disabled={Object.keys(errors).length > 0 || loading}
              onClick={() => handleSave(true)}
              data-style={EXPAND_RIGHT}
            >
              {booking ? "Booking..." : "Book All"}
            </LaddaButton>
          </React.Fragment>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ModalRecurringCommission;
